import STEP_NAMES from '@/forms/constants/step-names';

import {
  NOT_ELIGIBLE,
  ELIGIBLE,
  APPROVED,
  REJECTED,
  CONDITIONALLY_APPROVED,
  TECHNICAL_ERROR,
  //REJECTED_BUREAU_SCORE,

} from '@/forms/constants/onboarding-logic';

const GA_CATEGORY = 'Onboarding';
const DEFAULT = 'defaultCase';
const GA_EVENTS_ACTION_MAP = [
  {
    stepName: STEP_NAMES.welcome,
    name: 'Welcome Screen',
    actions: [
      {
        actionName: 'Basic Eligibility',
        key: DEFAULT,
      },
    ],
  },
  {
    stepName: STEP_NAMES.eligibility,
    name: 'Eligibility',
    actions: [
      {
        actionName: 'Mobile Verification',
        key: DEFAULT,
      },
    ],
  },
  {
    stepName: STEP_NAMES.contactCodeVerification,
    name: 'Contact Verification',
    actions: [
      {
        actionName: 'Eligible-Basic',
        key: ELIGIBLE,
      },
      {
        actionName: 'Not Eligible-Basic',
        key: NOT_ELIGIBLE,
      },
    ],
  },
  {
    stepName: STEP_NAMES.identityReview,
    name: 'Identity Verification',
    actions: [
      {
        actionName: 'Not Eligible-Bureau Score',
        key: NOT_ELIGIBLE,
      },
      {
        actionName: 'Eligible-Bureau Score',
        key: ELIGIBLE,
      },
    ],
  },
  {
    stepName: STEP_NAMES.employment,
    name: 'Employment Details',
    actions: [
      {
        actionName: 'Employment Check Completed',
        key: DEFAULT,
      },
    ],
  },
  {
    stepName: STEP_NAMES.incomeVerification,
    name: 'Income Verification',
    actions: [
      {
        actionName: 'Decision - Approve',
        key: APPROVED,
      },
      {
        actionName: 'Decision - Reject',
        key: REJECTED,
      },
      // {
      //   actionName: 'Decision - Reject Bureau Score',
      //   key: REJECTED_BUREAU_SCORE,
      // },
      {
        actionName: 'Decision - Conditional Approval',
        key: CONDITIONALLY_APPROVED,
      },
      {
        actionName: 'Decision - Error',
        key: DEFAULT,
      },
      {
        actionName: 'Decision - Technical Error',
        key:TECHNICAL_ERROR,
      },
    ],
  },
  {
    stepName: STEP_NAMES.creditCardLimit,
    name: 'Offer Detail',
    actions: [
      {
        actionName: 'Offer Check Completed',
        key: DEFAULT,
      },
    ],
  },
  {
    stepName: STEP_NAMES.loanReview,
    name: 'Offer Detail',
    actions: [
      {
        actionName: 'Offer Check Completed',
        key: DEFAULT,
      },
    ],
  },
  {
    stepName: STEP_NAMES.loanReviewConfirmation,
    name: 'Accept Offer Button',
    actions: [
      {
        actionName: 'Offer Accepted',
        key: DEFAULT,
      },
    ],
  },
  {
    stepName: STEP_NAMES.creditCardLimitReview,
    name: 'Accept Offer Button',
    actions: [
      {
        actionName: 'Offer Accepted',
        key: DEFAULT,
      },
    ],
  },
  {
    stepName: STEP_NAMES.appointment,
    name: 'Appointment',
    actions: [
      {
        actionName: 'Appointment Scheduled',
        key: DEFAULT,
      },
    ],
  },
  {
    stepName: STEP_NAMES.feedback,
    name: 'Reject Offer Button',
    actions: [
      {
        actionName: 'Offer Rejected',
        key: DEFAULT,
      },
    ],
  },
];

export {
  GA_CATEGORY,
  GA_EVENTS_ACTION_MAP,
  DEFAULT,
};
